import * as React from 'react';

// material-ui
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { TextAlignProperty } from 'csstype';

interface Props {
  className: string;
  title: string;
  titleAlign: TextAlignProperty;
  rightButtonText?: string;
  rightButtonAction?: Function;
  rightButtonDisabled?: boolean;
  showLoadingRightButton?: boolean;
}

interface States {
}

class SectionPanel extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      className,
      title,
      titleAlign,
      rightButtonText
    } = this.props;

    const panelBorderRadius: string = '10px';

    return (
      <Paper zDepth={2} className={className} style={{borderRadius: panelBorderRadius}}>
        <AppBar
          title={title}
          showMenuIconButton={false}
          iconElementRight={
            (rightButtonText) ? this.renderRightButton() : null
          }
          titleStyle={{textAlign: titleAlign}}
          style={{borderTopLeftRadius: panelBorderRadius, borderTopRightRadius: panelBorderRadius}}
        />
          {this.props.children}
      </Paper>
    );
  }

  private renderRightButton = (): JSX.Element => {
    const {
      rightButtonText,
      rightButtonAction,
      rightButtonDisabled,
      showLoadingRightButton
    } = this.props;
    
    return (
      (showLoadingRightButton) ?
        (
          <RefreshIndicator
            size={40}
            left={10}
            top={0}
            status="loading"
            style={{
              display: 'inline-block',
              position: 'relative',
              float: 'right',
              marginRight: '1rem'
            }}
          />
        ) :
        (
          <FlatButton
            label={rightButtonText}
            onClick={() => {
              if (rightButtonAction) {
                rightButtonAction();
              }
            }}
            disabled={rightButtonDisabled}
          />
        )
    );
  }  
}

export default SectionPanel;


// WEBPACK FOOTER //
// ./src/util/SectionPanelComponent.tsx